import { CalendarDate } from '#utils/UNSAFE_calendarDateUtils';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { unwrapElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
export class InputDatePickerAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the component
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change and commit the value of the component
   * @param value {CalendarDate | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: CalendarDate | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();
    // Scripts can only reference local variables.
    const newValue = value;

    // Note, webdriver sends null instead of undefined so we adjust it before calling _changeValue.
    await driver.executeScript(
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      (el: any, newValue: CalendarDate | undefined) => el._changeValue(newValue ?? undefined),
      unwrapElement(el),
      newValue
    );
  }
}
